import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Grid, Toolbar, Typography } from '@mui/material';
import Card from './Card';
import DoughnutChart from './DonutChart';

import { classes } from './utils';
import { getTotalOrganizationNumber } from '../../../../services/organizationDetails';

const CommonGrid = ({ isCard }) => {
  const [organizationDetails, setOrganizationDetails] = useState('');
  const getFilterSortData = async () => {
    try {
      const response = await getTotalOrganizationNumber();
      setOrganizationDetails(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);
  return (
    <>
      {isCard ? null : (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static" className={classes.externalHeaderAppBar}>
            <Toolbar variant="dense">
              <Typography
                variant="h5"
                component="div"
                className={classes.externalHeaderTitle}
              >
                Organization Status
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      )}
      <Grid container spacing={3} mt={3.5} marginTop="-39px">
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {isCard ? (
            <Card />
          ) : (
            <DoughnutChart
              totalOrganization={organizationDetails?.totalOrganization || 0}
              remainingOrganization={0}
              chartDetails="Total Organizations"
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {isCard ? (
            <Card />
          ) : (
            <DoughnutChart
              totalOrganization={organizationDetails?.activeOrganization || 0}
              remainingOrganization={
                organizationDetails?.inactiveOrganization || 0
              }
              chartDetails="Active Organizations"
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {isCard ? (
            <Card />
          ) : (
            <DoughnutChart
              totalOrganization={organizationDetails?.inactiveOrganization || 0}
              remainingOrganization={
                organizationDetails?.activeOrganization || 0
              }
              chartDetails="Inactive Organizations"
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {isCard ? (
            <Card />
          ) : (
            <DoughnutChart
              totalOrganization={0}
              remainingOrganization={organizationDetails?.totalOrganization}
              chartDetails="Trial Users"
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

CommonGrid.propTypes = {
  isCard: PropTypes.bool.isRequired,
};

export default CommonGrid;
